<template>
  <div :class="dialogClasses">
    <VCard
        :no-padding="noPadding"
        :style="dialogContentStyles"
        @closeButtonClick="close"
        class="mds-dialog-content"
        :closable="closable"
    >
      <template v-if="haveHeaderSlot" v-slot:header>
        <slot name="header" />
      </template>

      <template v-if="haveActionSlot" v-slot:action>
        <slot name="action" />
      </template>

      <slot />

      <template v-if="haveFooterSlot" v-slot:footer>
        <slot name="footer" />
      </template>
    </VCard>
  </div>
</template>

<style lang="scss" src="./VDialog.scss"/>

<script lang="ts">

import DialogsService from "@/core/services/Dialogs/DialogsService";
import Core from "@/core/Core";
import Constants from "@/core/misc/Constants";

const DIALOG_POSITIONS = ["center", "top", "right", "bottom", "left"];

export default defineComponent({
  name: "VDialog",

  emits: ['close'],

  props: {
    position: {
      type: String,
      default: "center",
      validator(value) {
        return DIALOG_POSITIONS.includes(value);
      },
    },
    /**
     * Ширина диалога. Задается как свойство ширины css.
     */
    width: {
      type: String,
      default: null,
      validator: (value) => Constants.CSS_SIZE_REGEXP.test(value) !== false,
    },

    /**
     * Высота диалога. Задается как свойство высоты css.
     */
    height: {
      type: String,
      default: null,
      validator: (value) => Constants.CSS_SIZE_REGEXP.test(value) !== false,
    },
    noPadding: {
      type: Boolean,
      default: false,
    },

    /**
     * Показать кнопку закрытия
     */
    closable: {
      type: Boolean,
      default: false,
    },
    notHideOnClick: {
      type: Boolean,
      default: false,
    },
    confirmBeforeClose: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    dialogClasses() {
      const result = {
        "mds-dialog": true,
        "visible": true
      };
      result[this.position] = true;
      return result;
    },

    dialogContentStyles() {
      const result: { width?: string; height?: string } = {};
      if (this.width) result.width = this.width;
      if (this.height) result.height = this.height;
      return result;
    },

    haveHeaderSlot() {
      return !!this.$slots["header"];
    },

    haveActionSlot() {
      return !!this.$slots["action"];
    },

    haveFooterSlot() {
      return !!this.$slots["footer"];
    },

    parentDialogName(): string {
      const name = this.$parent?.$options?.__name || this.$parent?.$options?.name;
      if (!name) {
        throw new Error('VDialog должен быть внутри именованного компонента');
      }
      return name;
    }
  },

  mounted() {
    this.setupClickListener();
  },

  beforeUnmount() {
    this.removeClickListener();
  },

  methods: {
    setupClickListener() {
      if (this.notHideOnClick === false) {
        window.addEventListener("click", this.onOverlayClick);
      }
    },

    removeClickListener() {
      window.removeEventListener("click", this.onOverlayClick);
    },

    async close() {
      if (this.confirmBeforeClose) {
        if (await Core.confirm('Уверены?')) {
          this.$emit('close');
          DialogsService.hide(this.parentDialogName);
        }
      } else {
        this.$emit('close');
        DialogsService.hide(this.parentDialogName);
      }
    },

    onOverlayClick(event) {
      if (event.target === this.$el) {
        this.close();
      }
    },
  },
});
</script>
